import axios from 'axios';

const API_BASE = process.env.REACT_APP_ENVIRONMENT === 'development'
  ? (process.env.REACT_APP_API_BASE_URL_DEV || 'http://localhost:3001/api')
  : (process.env.REACT_APP_API_BASE_URL || 'https://api-confereai.robotia.com.br/api');

const CLIENT_TOKEN_KEY = 'confereai_client_token';
export const CLIENT_USER_KEY = 'confereai_client_user';

export const getClientToken = (): string | null => localStorage.getItem(CLIENT_TOKEN_KEY);
export const getClientUser = (): any => {
  const u = localStorage.getItem(CLIENT_USER_KEY);
  if (!u) return null;
  try {
    return JSON.parse(u);
  } catch {
    localStorage.removeItem(CLIENT_USER_KEY);
    return null;
  }
};
export const isClientLoggedIn = (): boolean => !!getClientToken() && !!getClientUser();
export const clientLogout = () => {
  localStorage.removeItem(CLIENT_TOKEN_KEY);
  localStorage.removeItem(CLIENT_USER_KEY);
};

function getHeaders() {
  const token = getClientToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
}

async function clientApi(method: string, path: string, data?: any, params?: any) {
  try {
    const response = await axios({
      method,
      url: `${API_BASE}/client-dashboard${path}`,
      headers: getHeaders(),
      data,
      params
    });
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 401) {
      clientLogout();
      window.location.href = '/cliente/login';
    }
    throw error;
  }
}

export const clientDashboardService = {
  // Auth
  login: async (email: string, senha: string) => {
    const response = await clientApi('POST', '/login', { email, senha });
    if (response.success && response.token) {
      localStorage.setItem(CLIENT_TOKEN_KEY, response.token);
      localStorage.setItem(CLIENT_USER_KEY, JSON.stringify(response.usuario));
    }
    return response;
  },

  loginWithCarrier: async (email: string, senha: string, empresa_id: number) => {
    const response = await clientApi('POST', '/login', { email, senha, empresa_id });
    if (response.success && response.token) {
      localStorage.setItem(CLIENT_TOKEN_KEY, response.token);
      localStorage.setItem(CLIENT_USER_KEY, JSON.stringify(response.usuario));
    }
    return response;
  },

  getMe: () => clientApi('GET', '/me'),

  // Multi-carrier
  getMinhasTransportadoras: () => clientApi('GET', '/me/transportadoras'),
  trocarTransportadora: async (empresa_id: number) => {
    const response = await clientApi('POST', '/me/trocar-transportadora', { empresa_id });
    if (response.success && response.token) {
      localStorage.setItem(CLIENT_TOKEN_KEY, response.token);
      localStorage.setItem(CLIENT_USER_KEY, JSON.stringify(response.usuario));
    }
    return response;
  },

  // Dashboard data
  getMetrics: (filters: any = {}) => clientApi('GET', '/metrics', undefined, filters),
  getCharts: (filters: any = {}) => clientApi('GET', '/charts', undefined, filters),
  getPallets: (filters: any = {}) => clientApi('GET', '/pallets', undefined, filters),
  getPerformance: (filters: any = {}) => clientApi('GET', '/performance', undefined, filters),
  getOrders: (filters: any = {}) => clientApi('GET', '/orders', undefined, filters),
  getOrderDetail: (numeroPedido: string) => clientApi('GET', `/orders/${numeroPedido}`),
  getConsolidated: (filters: any = {}) => clientApi('GET', '/consolidated', undefined, filters),
  getConsolidatedAdvanced: (filters: any = {}) => clientApi('GET', '/consolidated/advanced', undefined, filters),
  getAnalytics: (filters: any = {}) => clientApi('GET', '/analytics', undefined, filters),

  // Password
  changePassword: (senhaAtual: string, novaSenha: string) =>
    clientApi('PUT', '/me/password', { senhaAtual, novaSenha }),

  // Integrations (mantido para compatibilidade)
  getIntegrations: () => clientApi('GET', '/integrations'),
  addIntegration: (token: string) => clientApi('POST', '/integrations', { token }),
  removeIntegration: (id: number) => clientApi('DELETE', `/integrations/${id}`),

  // Preferências do dashboard
  getPreferencias: () => clientApi('GET', '/preferencias'),
  updatePreferencias: (preferencias: any) => clientApi('PUT', '/preferencias', { preferencias })
};
